module.exports = __webpack_public_path__ + "media/assets/images/flags/sb-89c371925ae95808b66511cdfde7edb7.svg";